export default "__VITE_ASSET__CR7K79J7__"